
import { eoRendererMixin } from '~/mixins'

export default {
  mixins: [eoRendererMixin],
  props: {
    podcastId: {
      type: String,
      default: '',
    },
    podcastData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    podcastExtraContent: {
      type: Array,
      default: () => [],
    },
  },
  asyncData ({ store, route, params: { podcast } }) {
    store.dispatch('breadcrumbs/mirror', {
      path: route.path,
      mirror: `/podcasts/${podcast}`,
    })
  },
  data () {
    return {
      podcastArticles: [],
    }
  },
  async fetch () {
    if (this.podcastId) {
      // Get podcast articles
      const { data: { items: podcastArticles = [] } = {} } = await this.$api.podcasts.getAllNested(
        'articles',
        this.podcastId,
        {
          offset: 0,
          limit: 8,
        },
      )
      this.podcastArticles = podcastArticles
    }
  },
  computed: {
    title () {
      return this.podcastData.title
    },
  },
}
